import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SyncDataService } from './../../services/sync-data.service';
import { ACustomStepWizard } from '../../../shared/components/wizard/step-wizard/abstract-custom-step-wizard';
import { Observable, of } from 'rxjs';
import { IFacadeTableDescriptor } from 'app/core/typings/IFacadeTableDescriptor';
import { IFacadeExportObject } from 'app/core/typings/IFacadeExportObject';

@Component({
  selector: 'app-export-step10',
  templateUrl: './export-step10.component.html',
  styleUrls: ['./export-step10.component.scss', '../../sync-data.component.scss']
})
export class ExportStep10Component extends ACustomStepWizard<{ syncData: IFacadeExportObject }> implements OnChanges {
  @Input() data;
  @Input() exportOnlyUsers: boolean = false;
  @Output() exportFirstTab = new EventEmitter<boolean>();
  public selectedTables: IFacadeTableDescriptor[];
  public unselectedTables: IFacadeTableDescriptor[];
  public itemsSelectedLeft = '0';
  public itemsSelectedRight = '0';
  public responseError: string;
  public activeTab = 1;

  private selectedEntityItemsUI: IFacadeTableDescriptor[];
  private selectedUserItemsUI: IFacadeTableDescriptor[];
  private usersTable: IFacadeTableDescriptor;

  constructor(private _syncDataService: SyncDataService) {
    super('')
  }

  ngOnChanges(): void {
    if (this.data) {
      this.load();
    }

    if (this.exportOnlyUsers) {
      this.isValid();
    }
  }

  public load() {
    this.getAvailableTables();
  }

  public isValid(): Observable<boolean> {
    this.data.syncData.EntityTables.forEach((item) => item.SelectedUI = false);
    if (this.data.syncData.UserTables &&
      this.data.syncData.UserTables.length > 0 &&
      this.data.syncData.UserTables.filter(table => table.Selected === true).length > 0 &&
      this.selectedTables.findIndex((item) => item.TableName.toUpperCase() === 'WFUSER') === -1) {
      this.usersTable.Selected = true;
    }
    this.exportFirstTab.emit();
    return of(true);
  }

  public changeSelected(selected) {
    selected.SelectedUI = !selected.SelectedUI;
  }

  private getAvailableTables(): void {
    if ((!this.data.syncData.EntityTables &&
      !this.data.syncData.UserTables) || (this.data.syncData.EntityTables.length === 0 &&
        this.data.syncData.UserTables.length === 0)) {
      this._syncDataService.getTables().then((serverData: IFacadeExportObject) => {
        this.data.syncData.EntityTables = serverData.EntityTables;
        this.data.syncData.UserTables = serverData.UserTables;
        this.data.syncData.ModifiedDescriptor = serverData.ModifiedDescriptor;
        this.data.syncData.OriginalDescriptor = serverData.OriginalDescriptor;
        this.usersTable = this.data.syncData.UserTables.find(item => item.TableName.toUpperCase() === 'WFUSER');
        this.refreshList(false, '', '');
      })
        .catch(error => {
          this.responseError = error.message;
        });
    }
    else {
      this.data.syncData.EntityTables.forEach((item) => item.SelectedUI = false);
      this.refreshList(true, '', '');
    }
  }

  public moveAll(toExport: boolean, searchValueUnselected: string, searchValueSelected: string) {
    if (toExport) {
      this.unselectedTables.forEach((item) => item.SelectedUI = true);
    } else {
      this.selectedTables.forEach((item) => item.SelectedUI = true);
    }

    this.refreshList(toExport, searchValueUnselected, searchValueSelected);
  }

  public refreshList(toExport: boolean, searchValueUnselected: string, searchValueSelected: string): void {
    this.selectedEntityItemsUI = this.data.syncData.EntityTables.filter(
      item => item.Selected === !toExport && item.SelectedUI === true);
    this.selectedEntityItemsUI.forEach((item) => item.Selected = toExport);
    this.selectedEntityItemsUI.forEach((item) => item.SelectedUI = toExport);
    this.selectedUserItemsUI = this.data.syncData.UserTables.filter(
      item => item.Selected === !toExport && item.SelectedUI === true);
    this.selectedUserItemsUI.forEach((item) => item.Selected = toExport);
    this.selectedUserItemsUI.forEach((item) => item.SelectedUI = toExport);

    this.onSearchChange(searchValueUnselected, searchValueSelected);
  }

  public onSearchChange(searchValueUnselected: string, searchValueSelected: string) {
    if (searchValueUnselected.length > 0) {
      this.unselectedTables = this.activeTab === 1 ?
        this.data.syncData.EntityTables.filter(table =>
          (table.DisplayName.toUpperCase().indexOf(searchValueUnselected.toUpperCase()) > -1) &&
          (table.Selected === false)) :
        this.data.syncData.UserTables.filter(table =>
          (table.DisplayName.toUpperCase().indexOf(searchValueUnselected.toUpperCase()) > -1) &&
          (table.Selected === false));
    }
    else {
      this.unselectedTables = this.activeTab === 1 ?
        this.data.syncData.EntityTables.filter(table => table.Selected === false) :
        this.data.syncData.UserTables.filter(table => table.Selected === false);
    }

    if (searchValueSelected.length > 0) {
      this.selectedTables = _.concat(
        this.data.syncData.EntityTables.filter(table =>
          (table.DisplayName.toUpperCase().indexOf(searchValueSelected.toUpperCase()) > -1) &&
          (table.Selected === true)),
        this.data.syncData.UserTables.filter(table =>
          (table.DisplayName.toUpperCase().indexOf(searchValueSelected.toUpperCase()) > -1) &&
          (table.Selected === true)));
    }
    else {
      this.selectedTables = _.concat(this.data.syncData.EntityTables.filter(table => table.Selected === true),
        this.data.syncData.UserTables.filter(table => table.Selected === true));
    }

    this.unselectedTables = this._syncDataService.orderEntityList(this.unselectedTables);
    this.selectedTables = this._syncDataService.orderEntityList(this.selectedTables);
    this.refreshCount();
  }

  private refreshCount() {
    this.itemsSelectedLeft = this.unselectedTables.length.toString();
    this.itemsSelectedRight = this.selectedTables.length.toString();
  }
}
